<template>
    <section class="section buscar-page">
        <div class="field">
            <p class="control has-icons-left" :class="{'is-loading' : this.loading}">
                <input type="text" class="input" v-model="search" v-on:input="search = $event.target.value" placeholder="Buscar...">
                <span class="icon is-small is-left">
                    <font-awesome-icon icon="search" />
                </span>
            </p>
        </div>
        <div class="tabs is-fullwidth">
            <ul>
                <li :class="{'is-active' : buscarUsuarios}">
                    <a @click.prevent="ver('jugadores')">
                        <span class="icon"><font-awesome-icon icon="users" /></span>
                        <span>Jugadores</span>
                    </a>
                </li>
                <li :class="{'is-active' : buscarQuinielas}">
                    <a @click.prevent="ver('quinielas')">
                        <span class="icon"><font-awesome-icon icon="check-square" /></span>
                        <span>Todas las quinielas</span>
                    </a>
                </li>
            </ul>
        </div>

        <div class="search-list" v-if="buscarUsuarios">
            <div v-if="usuariosResults != undefined && usuariosResults.length == 0" class="section has-text-centered">No hay resultados</div>
            <router-link :to="'/perfil/' + usuario.id" v-for="usuario in usuariosResults" :key="usuario.id">
                <article class="media is-fullwidth">
                    <figure class="media-left">
                        <p class="image is-48x48">
                            <img class="is-rounded" :src="usuario.image" alt="">
                        </p>
                    </figure>
                    <div class="media-content">
                        {{ usuario.name }}
                    </div>
                    <div class="media-right">
                        <SeguirButton :userFollow="usuario" />
                    </div>
                </article>
            </router-link>
        </div>

        <div class="search-list" v-if="buscarQuinielas">
            <div v-if="quinielasResults != undefined && quinielasResults.length == 0" class="section has-text-centered">No hay resultados</div>
            <router-link :to="'/ver-quiniela/' + quiniela.id" v-for="quiniela in quinielasResults" :key="quiniela.id">
                <article class="media is-fullwidth">
                    <div class="media-left">
                        <span v-if="quiniela.tipo == 0" class="icon"><font-awesome-icon icon="file" /></span>
                        <span v-if="quiniela.tipo == 1" class="icon"><font-awesome-icon icon="users" /></span>
                    </div>
                    <div class="media-content">
                        {{ quiniela.nombre }}
                        <span class="tag" :class="classEstado(quiniela.estado)">{{ estadoText(quiniela.estado) }}</span>
                    </div>
                    <div class="media-right">
                        <span class="icon" v-if="quiniela.privada"><font-awesome-icon icon="lock" /></span>
                        <span class="icon"><font-awesome-icon icon="coins" /></span>
                        <span>{{quiniela.apuesta}}</span>
                    </div>
                </article>
            </router-link>
        </div>

    </section>
</template>

<script>
    import QuinielazoService from '@/services/QuinielazoService'
    import { debounce } from 'lodash'
    import quiniMixin from '@/mixins/quiniMixin'

    export default {
        name: 'Buscar',
        mixins: [quiniMixin],
        data() {
            return {
                search: '',
                buscarUsuarios: true,
                buscarQuinielas: false,
                usuariosResults: [],
                quinielasResults: [],
                loading: false
            }
        },
        watch: {
            search: debounce(function(){
                if (this.buscarUsuarios) {
                    this.getJugadores()
                }else{
                    this.getQuinielas()
                }
            },500)
        },
        methods: {
            ver(opcion){
                if (opcion == "jugadores") {
                    this.buscarUsuarios = true
                    this.buscarQuinielas = false
                    this.getJugadores()
                }else{
                    this.buscarUsuarios = false
                    this.buscarQuinielas = true
                    this.getQuinielas()
                }
            },
            getJugadores(){
                this.loading = true
                QuinielazoService.buscarJugador(this.search)
                .then(res => {
                    this.usuariosResults = res.data
                    this.loading = false
                })
            },
            getQuinielas(){
                this.loading = true
                QuinielazoService.buscarQuiniela(this.search)
                .then(res => {
                    this.quinielasResults = res.data
                    this.loading = false
                })
            }
        },
    }
</script>

<style lang="css" scoped>
.buscar-page{
    padding: 1rem 1rem;
}
/* .buscar-page{
    padding: 1rem 0em 0em;
} */
.buscar-page .tabs{
    margin-bottom: 0;
}
.search-list a{
    color: black;
}
.search-list a article{
    padding: .5em;
    align-items: center;
}
.search-list a:not(:last-child) article{
    border-bottom: 1px solid #dbdbdb;
}
.buscar-page .tabs li a{
    color: #aaa;
}
.buscar-page .tabs li.is-active a{
    color: #000;
    border-bottom-color: #000;
}
@media (min-width: 1024px) { /* Desktop */
    .buscar-page{
        padding: 1em 3em;
        min-height: 400px;
    }
}
</style>